const save = {
    success: false,
    isLoading: false,
    error: false,
};

const results = {
    isLoading: false,
    success: false,
    error: false,
    data: []
};

const content = {
    save,
    ...save
};

const defaultState = {
    content,
    results,
    reload: false,
    ...save
};

const subdomain = window.location.host.split('.')[0];

if (!localStorage.hasOwnProperty('_LOCALE')) {
    localStorage.setItem('_LOCALE', subdomain === 'italia' ? 'it' : 'pt');
}

const city = ["italia", "europa"].includes(subdomain) ? {
    key: 7,
    text: "IN Europa",
    slug: "in-europa",
    value: 7
} : {
    key: 1,
    text: "Belo Horizonte",
    slug: "belo-horizonte",
    value: 1
};

if(city['key'] >= 6 ){
    document.title = 'IN EUROPA';
}

if (!localStorage.hasOwnProperty('_CITY')) {
    localStorage.setItem('_CITY', JSON.stringify(city));
}

const locale = localStorage.getItem('_LOCALE');

const API_URL = process.env.NODE_ENV === "developmentxz"
    ? "http://localhost:8080"
    : "https://br.inbh.com.br";

export const APP = {
    API_URL,
    defaultState,
    locale,
    fbid: 3263318010352246,
    banner: `${API_URL}/files/banners`,
    cities: `${API_URL}/files/cities`,
    images: {
        cities:{
            path: `${API_URL}/files/cities/image/`,
        },
        categories: {
            path: `${API_URL}/files/categories/image/`,
            big: `${API_URL}/img/defaults/categories/big.jpg`,
            small: `${API_URL}/img/defaults/categories/small.jpg`,
            image: `${API_URL}/img/defaults/categories/small.jpg`
        },
        places: {
            path: `${API_URL}/files/places/banner/`,
            big: `${API_URL}/img/defaults/places/big.jpg`,
            small: `${API_URL}/img/defaults/places/small.jpg`
        },
        posts: {
            path: `${API_URL}/files/posts/image/`,
            banner: `${API_URL}/files/posts/banner/`,
            banner_mobile: `${API_URL}/files/posts/banner_mobile/`,
        },
        courses: {
            banner: `${API_URL}/files/courses/banner/`,
        }
    }
};
